import React from 'react'
import './skills.css'
import Frontend from './Frontend'
import Backend from './Backend'
import Other from './Other'
import skillsData from './skillsData.json'

const Skills = () => {
  return (
    <section className="skills section" id="skills">
        <h2 className="section__title">Skills</h2>
        <span className="section__subtitle">My technical level</span>

        <div className="skills__container container grid">
            <Frontend skills={skillsData.frontend} title="Programming Languages" />
            <Backend skills={skillsData.backend} title="Analysis & Visualization Tools" />
            <Other skills={skillsData.other} title="Other" />
        </div>
    </section>
  )
}

export default Skills
